import { EdgeUploadProfilePhotoRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { UploadProfilePhoto } from '@/modules/auth/use-cases'

export function makeUploadProfilePhoto(): UploadProfilePhoto {
  return new EdgeUploadProfilePhotoRepository(makeSupabaseEdgeHttpClient()).execute
}
